import { gql, TypedDocumentNode } from "@apollo/client";

import { BlueprintDeployment, QueryBlueprintDeploymentArgs } from "types/generated";

type BlueprintDeploymentData = {
  blueprintDeployment: BlueprintDeployment;
};

export const BLUEPRINT_DEPLOYMENT_QUERY: TypedDocumentNode<
  BlueprintDeploymentData,
  QueryBlueprintDeploymentArgs
> = gql`
  query BlueprintDeployment($blueprintID: ID!, $id: ID!) {
    blueprintDeployment(blueprintID: $blueprintID, id: $id) {
      id
      name
      description
      state
      blueprint {
        id
      }
      blueprintVersion {
        id
        version
      }
      space {
        id
      }
      createdAt
      inputs {
        id
        value
        secret
      }
      stacks {
        id
        name
        state
        outputs {
          id
          value
          description
          sensitive
        }
      }
    }
  }
`;
